import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { WebDeveloperAboutUsComponent } from './web-developer/web-developer-about-us/web-developer-about-us.component';
import { WebDeveloperContactUsComponent } from './web-developer/web-developer-contact-us/web-developer-contact-us.component';
import { WebDeveloperIndexComponent } from './web-developer/web-developer-index/web-developer-index.component';
import { WebDeveloperPortfolioComponent } from './web-developer/web-developer-portfolio/web-developer-portfolio.component';
import { WebDeveloperResumeComponent } from './web-developer/web-developer-resume/web-developer-resume.component';

const routes: Routes = [
  { path: '', component: WebDeveloperIndexComponent },

  { path: 'about-us-web-developer', component: WebDeveloperAboutUsComponent },
  { path: 'contact-us-web-developer', component: WebDeveloperContactUsComponent },
  { path: 'index-web-developer', component: WebDeveloperIndexComponent },
  { path: 'portfolio-web-developer', component: WebDeveloperPortfolioComponent },
  { path: 'resume-web-developer', component: WebDeveloperResumeComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
